import  { useState } from 'react'

export const ApListState = () => {
    const [apSearch, setApSearch] = useState('')

  return {
        apSearch: {data: apSearch, set: setApSearch}
   
  }
  
}
